//Set fonts for the page
import { createGlobalStyle } from 'styled-components';
import { MOBILE_BREAKPOINT, SELECTORS, TABLET_BREAKPOINT, UBISOFT_BLUE } from '../../constants';
import { ITheme } from '../themes';

export const GlobalStyles = createGlobalStyle<{theme : ITheme}>`
    ${SELECTORS} & {
      //Unset sfcc styles
      .pt_content #primary {
        max-width: unset; 
        margin: unset; 
        padding: unset; 
      }
      
      //Font families and font colors
      body{
        background: #1F2226;
      }
    
      img{
       max-width: unset;
      }
        
      h1,h2,h3,
      a,p
      {
        color: white;
        //Unset sfcc provided styles
        text-transform: unset;
        margin: unset;
        
        //Remove the after bar set by sfcc
        &:after {
          content: none !important;
        }
      }
      
      //Font family setup
      h1,h2,h3{
        font-family: ${props => props.theme.boldFont};
        font-weight: ${props => props.theme.fontWeight};
        span{
          font-family: ${props => props.theme.boldFont};
          font-weight: ${props => props.theme.fontWeight};
          color: ${UBISOFT_BLUE};
        }
      }
      
      p,a{
        font-family: ${props => props.theme.font};
        span,a{
          font-family: ${props => props.theme.font};
          color: ${UBISOFT_BLUE};
        }
      }
      
      //Font sizes setup
      //H1 Text
      h1{
        font-size: 48px;
        line-height: 58px;
        span{
          font-size: 48px;
          line-height: 58px;;
        }
        @media (max-width: ${TABLET_BREAKPOINT}) {
            font-size: 32px;
            line-height: 38px;
            span{
              font-size: 32px;
              line-height: 38px;
            }
        }
        @media (max-width: ${MOBILE_BREAKPOINT}) {
        
            span{
            
            }
        }
      }
      
      //H2 Text
      h2{
        font-size: 40px;
        span{
          font-size: 40px;
        }
        @media (max-width: ${TABLET_BREAKPOINT}) {
            
            span{
            
            }
        }
        @media (max-width: ${MOBILE_BREAKPOINT}) {
        
            span{
            
            }
        }
      }
      
      //H3 Text
      h3{
        font-size: 40px;
        line-height: 50px;
        span{
          font-size: 40px;
          line-height: 50px; 
        }
        @media (max-width: ${TABLET_BREAKPOINT}) {
            font-size: 24px;
            line-height: 28.8px;
            span{
              font-size: 24px;
              line-height: 28.8px;
            }
        }
      }
      
      //p Text
      p{
        font-size: 24px;
        line-height: 28.8px;
        span{
          font-size: 24px;
          line-height: 28.8px;
        }
        @media (max-width: ${TABLET_BREAKPOINT}) {
            font-size: 16px;
            line-height: 19.2px;
            span{
              font-size: 16px;
              line-height: 19.2px;
            }
        }
     }
     
     sup{
        font-size: 0.6em;
        position: relative; 
        top: -0.5em;
      } 
    }
`;